import React from "react";
import { connect } from "react-redux";
import { compose } from "recompose";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import { Button } from "reactstrap";

import { setTitleOnPage } from "@app/util";
import { messages } from "@app/messages";
import { ReportsState } from "@reports/models";
import { messages as rMessages } from "@reports/messages";
import { CustomReportsList } from "@reports/components/CustomReportsList";
import { hasReportInProgress as hasReportInProgressSelector } from "@reports/selectors";
import { Page, PageTitle } from "@ui/Page";

const breadcrumbItems = [
    {
        text: <FormattedMessage {...messages.pageReportsTitle} />,
    },
];

interface ReportsIndexStateProps {
    hasReportInProgress: boolean;
}

type Props = ReportsIndexStateProps;
type State = ReportsState;

const ReportsIndex = ({ hasReportInProgress }: Props) => (
    <Page className="reports-index-page" breadcrumbs={breadcrumbItems}>
        <PageTitle tag="h1" className="display-2">
            <FormattedMessage {...rMessages.reportPlural} />
        </PageTitle>
        <p className="sub-heading">
            <FormattedMessage {...rMessages.customReportsIntro} />
        </p>
        <Button
            tag={Link}
            to="/reports/create"
            color="primary"
            disabled={hasReportInProgress}
        >
            <FormattedMessage {...rMessages.customReportsGenerateButton} />
        </Button>
        <CustomReportsList />
    </Page>
);

const mapStateToProps = (state: State): ReportsIndexStateProps => ({
    hasReportInProgress: hasReportInProgressSelector(state),
});

const ConnectedReportsIndex = compose<ReportsIndexStateProps, {}>(
    connect(mapStateToProps, null),
    setTitleOnPage(messages.pageReportsTitle),
)(ReportsIndex);

export {
    ReportsIndex as ReportsIndexPresenter,
    ConnectedReportsIndex as ReportsIndex,
};
